import { Navigate, Route, Routes } from "react-router-dom"
import { useStoreState } from "easy-peasy"
import Configure from "./Configure"
import Dashboard from "./Dashboard"
import DedupReview from "./DedupReview"
import Dmv from "./Dmv"
import Dog from "./Dog"
import DogAssignStaff from "./DogAssignStaff"
import DogFees from "./DogFees"
import DogTags from "./DogTags"
import DogTaxPayerFind from "./DogTaxPayerFind"
import Farm from "./Farm"
import Help from "./Help"
import Layout from "./Layout"
import Login from "./Login"
import Logout from "./Logout"
import PageNotFound from "./PageNotFound"
import Reports from "./Reports"
import User from "./User"
import UserAdd from "./UserAdd"
import UserEdit from "./UserEdit"
import UserModules from "./UserModules"
import UserResetPswd from "./UserResetPswd"

// We will need to purchase an SSL certificate from a trusted Certificate Authority
// This development software uses a self-signed certificate not suitable for production

function RequireAuth({ children }) {
	const LoggedIn = useStoreState((s) => s.LoggedIn)
	return LoggedIn ? children : <Navigate to="/login" replace />
}

function App() {
	return (
		<Routes>
			{/* Layout renders (header,nav,footer) and wraps all other routes */}
			<Route path="/" element={<Layout />}>
				<Route index element={<Login />} />
				<Route path="login" element={<Login />} />
				<Route path="configure" element={<RequireAuth><Configure /></RequireAuth>} />
				<Route path="dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
				<Route path="dog" element={<RequireAuth><Dog /></RequireAuth>} />
				<Route path="dog/assignstaff" element={<RequireAuth><DogAssignStaff /></RequireAuth>} />
				<Route path="dog/fees" element={<RequireAuth><DogFees /></RequireAuth>} />
				<Route path="dog/dogtags" element={<RequireAuth><DogTags /></RequireAuth>} />
				<Route path="farm" element={<RequireAuth><Farm /></RequireAuth>} />
				<Route path="dmv" element={<RequireAuth><Dmv /></RequireAuth>} />
				<Route
					path="license"
					element={<RequireAuth><Navigate to="/license/taxpayerfind" replace /></RequireAuth>}
				/>
				<Route path="license/taxpayerfind" element={<RequireAuth><DogTaxPayerFind /></RequireAuth>} />
				<Route path="license/duplicates" element={<RequireAuth><DedupReview /></RequireAuth>} />
				<Route path="logout" element={<RequireAuth><Logout /></RequireAuth>} />
				<Route path="reports" element={<RequireAuth><Reports /></RequireAuth>} />
				<Route path="user" element={<RequireAuth><User /></RequireAuth>} />
				<Route path="useradd" element={<RequireAuth><UserAdd /></RequireAuth>} />
				<Route path="useredit" element={<RequireAuth><UserEdit /></RequireAuth>} />
				<Route path="userresetpswd">
					<Route index element={<UserResetPswd />} />
					<Route path=":code" element={<UserResetPswd />} />
				</Route>
				<Route path="usermodules" element={<RequireAuth><UserModules /></RequireAuth>} />
				<Route path="help" element={<RequireAuth><Help /></RequireAuth>} />
				<Route path="*" element={<PageNotFound />} />
			</Route>
		</Routes>
	)
}

export default App
